import { TAX_OBL_LIABILITIES_ITEM } from './tax-obl-liabilities.js'
import { TAX_OBL_PAYMENTS_ITEM } from './tax-obl-payments.js'
import { TAX_OBL_PAYMENT_PLANS_ITEM } from './tax-obl-payment-plans.js'

/** @type {import('../help-index.js').HelpScreen} */
export const TAX_OBL_HELP = {
  screenId: 'tax-obl',
  label: 'Obligaciones impositivas',
  navPath: 'Impuestos → Obligaciones impositivas',
  keywords: [
    'obligación impositiva', 'iibb', 'sellos', 'pagar impuesto', 'vencimiento',
    'saldo a pagar', 'liquidación iva', 'plan de pago', 'cuotas impuesto',
    'interés mora', 'facilidades de pago',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Saldos a pagar por impuesto y período, pagos parciales y planes de pago con cuotas (capital e interés de financiación por separado).',
  sidebarItems: [
    TAX_OBL_LIABILITIES_ITEM,
    TAX_OBL_PAYMENTS_ITEM,
    TAX_OBL_PAYMENT_PLANS_ITEM,
  ],
}
